/* eslint-disable no-unused-vars */
declare global {
  interface Window {
    _HCID_ENV: any;
  }
}

import React, { Suspense, useEffect } from "react";
import NextHead from "../components/Seo/NextHead";
import Layout from "../components/Layout";
import BreadcrumbComponent from "../components/UserInterface/BreadcrumbComponent";
import { defaultURL, lokasiKamiMeta } from "../data/DataMetatags";
import { lokasiKamiBreadcrumb } from "../data/DataBreadcrumb";
import Head from "next/head";
import { GACustomEvent } from "src/utils/analytics";
import { PosLocator } from "src/remotes/PosLocator/components";
import ErrorBoundary from "src/components/ErrorBoundary";
import Reload from "src/components/Reload";
import { Text, UIProvider } from "src/components/UI";
import { env } from "src/utils/env";

const TemukanLokasiKami = ({ pageTitle, descriptionSEO, asPath }) => {
  const breadcrumb = [
    {
      "@type": "ListItem",
      position: "1",
      item: {
        "@id": defaultURL,
        name: "Home",
      },
    },
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": defaultURL + asPath,
        name: pageTitle,
      },
    },
  ];

  useEffect(() => {
    window._HCID_ENV = {
      APP_OPEN_STREET_MAP_API_URL: env.APP_OPEN_STREET_MAP_API_URL,
      APP_POS_LOCATOR_API_URL: env.APP_POS_LOCATOR_API_URL,
      APP_WEBSITE_URL: env.APP_WEBSITE_URL,
    };
    GACustomEvent("locate_us_search", "view");
  }, []);

  return (
    <UIProvider>
      <Layout>
        <Head>
          <script
            async
            id="markerclusterer"
            src="/vendor/markerclusterer/markerclusterer_compiled.js"
          />
        </Head>
        <NextHead
          title={pageTitle}
          description={descriptionSEO}
          url={asPath}
          breadcrumb={breadcrumb}
        />
        <BreadcrumbComponent items={lokasiKamiBreadcrumb} />

        <ErrorBoundary
          fallback={
            <Reload>
              <Text fontSize={20}>Pos Locator is not available</Text>
            </Reload>
          }
        >
          <Suspense fallback={<Text>loading...</Text>}>
            <PosLocator />
          </Suspense>
        </ErrorBoundary>
      </Layout>
    </UIProvider>
  );
};

TemukanLokasiKami.getInitialProps = async ({ asPath }) => {
  const pageTitle = lokasiKamiMeta.title;
  const descriptionSEO = lokasiKamiMeta.description;
  return { pageTitle, descriptionSEO, asPath };
};
export default TemukanLokasiKami;
